import { SquareButton } from "@themuse/design-system";
import { JobApplyButton } from "./JobApplyButton";

import styles from "./JobApplyButtonSideBarModule.module.scss";

interface JobApplyButtonSideBarModuleProps {
    jobState: string;
    jobId: number;
    trackJobApplyProps: any;
    setIsOpen?: (x: boolean) => void;
    isDirectApply: boolean;
}

export const JobApplyButtonSideBarModule = (props: JobApplyButtonSideBarModuleProps) => {
    const {
        jobState,
        jobId,
        trackJobApplyProps,
        setIsOpen,
        isDirectApply
    } = props;

    return (
        <div className={styles.jobApplyContainer}>
            {jobState === "live" ? (
                <JobApplyButton
                    className={styles.applyButton}
                    jobId={jobId}
                    trackingProps={trackJobApplyProps}
                    setIsOpen={setIsOpen}
                    isDirectApply={isDirectApply}
                />
            ) : (
                <div className={styles.archived}>
                    <p className={styles.archivedJobMessage}>This job is no longer available.</p>
                    <SquareButton
                        href="/search"
                        target="_blank"
                        color="mint"
                    >
                        Search all jobs
                    </SquareButton>
                </div>
            )}
        </div>
    );
};
JobApplyButtonSideBarModule.displayName = "JobApplyButtonSideBarModule";
